__turbopack_context__.v({
  "partialAccordion": "emVDBq_partialAccordion",
  "partialAccordionDetails": "emVDBq_partialAccordionDetails",
});
